import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'checkout-content-display-conditions',
  templateUrl: './checkout-content-display-conditions.component.html',
  styleUrls: ['./checkout-content-display-conditions.component.scss'],
  standalone: false,
})
export class CheckoutContentDisplayConditionsComponent {
  @Input() formGroup: FormGroup;
  @Input() shopCurrencySymbol: string;
}
